import { Routes, Route, RouterProvider } from "react-router-dom";
import PlannerList from "./PlannerList";
import PlannerForm from "./PlannerForm";


export default function Planner(){
return (
<Routes>
<Route path="/" element={<PlannerList/>} />
<Route path="new" element={<PlannerForm/>} />
<Route path="edit/:id" element={<PlannerForm/>} />
</Routes>
);
} //033 40071212; rpo kolkata

